<script>
import { pageRoute } from "@utils/network";
export default {
    name: "LogoutPage",
    methods: {
        logout() {
            this.$store.dispatch("logout");
            if (this.$route.query.relogin) {
                return window.location = pageRoute("login");
            }
            window.location = pageRoute("");
        }
    },

    mounted() {
        this.logout();
    },
}
</script>